// 用户管理
export const list = {
  realname: {
    key: 'realname',
    name: '姓名'
  },
  job_title: {
    key: 'job_title',
    name: '职位'
  },
  job_number: {
    key: 'job_number',
    name: '工号'
  },
  roles: {
    key: 'roles.role_name',
    name: '角色'
  }
  // email: {
  //   key: 'email',
  //   name: '邮箱',
  //   show: true,
  // },
  // phone: {
  //   key: 'phone',
  //   name: '电话',
  //   show: true,
  // }
}
